"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const LoyaltyWrapper = dynamic(
  async () => (await import("./LoyaltyWrapper")).LoyaltyWrapper,
  {
    ssr: false,
  }
);

export const loyaltyWrapperInputs = [
  {
    name: "name",
    type: "string",
    required: true,
    enum: [
      {
        label: "General",
        value: "general",
      },
      {
        label: "Account",
        value: "account",
      },
    ],
    defaultValue: "general",
  },
] as const satisfies Inputs;

export const LoyaltyWrapperComponent: RegisteredComponent = {
  name: "LoyaltyWrapper",
  component: LoyaltyWrapper,
  canHaveChildren: true,
  inputs: loyaltyWrapperInputs,
};
